<div class="container-fluid">
  @for (eventDetails of statusEvents; track eventDetails) {
    <div class="row p-2 row-table-style align-items-center justify-content-between">
      <div class="col-12 col-md-4 col-lg-2">
        <div class="d-flex align-items-center">
          <div class="status-icon"
            [title]="'statusDescription'">
            <em class="fa mr-3" [ngClass]="getTypeIcon(eventDetails.type)"></em>
          </div>
          <strong [innerHTML]="eventDetails.signalLabel | translate"></strong>
        </div>
      </div>
      <div class="col-12 col-md-4 col-lg-2">
        <span [innerHTML]="eventDetails.code"></span>
      </div>
      <div class="col-12 col-md-4 col-lg-2">
        <span [innerHTML]="eventDetails.description"></span>
      </div>
      <div class="col-12 col-md-4 col-lg-2">
        <span [innerHTML]="formatDate(eventDetails.timestamp)"></span>
      </div>
      <div class="col-auto">
        <button (click)="onRedirectToStatusPage(eventDetails.signalName)" class="btn btn-primary">
          <span class="fa-solid fa-arrow-right"></span>
        </button>
      </div>
    </div>
  }
  @if (isLoading) {
    <div class="text-center pt-4 pb-3">
      <button (click)="onLoadMore()" class="btn btn-primary">
        <span class="fa-solid fa-angles-down"></span>
        <span translate>Load more</span>
      </button>
    </div>
  }
</div>
